import axios from 'axios';
import API from './API.js'

export default class StudentCertifictae extends API {
  constructor() {
    super('certifictae')
  }
  async getUsers(params) {
    // console.log("api", params);
    try {
      const response = await axios.get(`certifictae/get-users`, { params })
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
}
